import { render, staticRenderFns } from "./CreatePostEdit.vue?vue&type=template&id=7aa6d900&"
import script from "./CreatePostEdit.vue?vue&type=script&lang=js&"
export * from "./CreatePostEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports